import React from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import {Header1} from 'ui-library/Headers';

import DataPoliciesListing from './DataPoliciesListing';

function DataPoliciesPage(): JSX.Element {
  const title = 'General access policies';
  React.useEffect(() => {
    setWindowTitle(title);
  }, [title]);
  return (
    <div className="settingsPage" {...getTestProps({component: 'DataPoliciesPage', element: 'root'})}>
      <div className="settingsPage-contentWrapper">
        <Header1>{title}</Header1>
        <div className="u-spacing-top">
          <DataPoliciesListing />
        </div>
      </div>
    </div>
  );
}

export default DataPoliciesPage;
